import FloatingPanel, {
  FloatingPanelContent as FloatingPanelContentComponent,
} from './FloatingPanel';
import './floating-panel.scss';

export const FloatingPanelContent = FloatingPanelContentComponent;
export default FloatingPanel;
